const styles = {
  container: {
    height: '100vh',
    padding: 'clamp(2rem, 3rem, 5rem) clamp(1rem, 2rem, 4rem)',
    backgroundColor: '#000',
    color: '#fff',
    textAlign: 'center',
    // maxWidth: '1440px',
    margin: '0 auto',
  },

  title: {
    fontSize: 'clamp(2rem, 3.125rem, 4rem)',
    fontFamily: 'Orbitron, sans-serif',
    marginBottom: 'clamp(1rem, 2rem, 3rem)',
  },

  carouselWrapper: {
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 'clamp(0.5rem, 1rem, 2rem)',
  },

  carousel: {
    display: 'flex',
    gap: 'clamp(4rem, 8.8rem, 12rem)',
    overflowX: 'scroll',
    scrollBehavior: 'smooth',
    padding: 'clamp(2rem, 5rem, 6rem) clamp(4rem, 24rem, 30rem)',
    scrollSnapType: 'x proximity',
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    cursor: 'grab',
    userSelect: 'none',
  },

  cardWrapper: {
    scrollSnapAlign: 'center',
    flexShrink: 0,
    transitionProperty: 'transform, opacity',
    transitionDuration: '0.4s',
    transitionTimingFunction: 'ease-in-out',
    userSelect: 'none',
  },

  cardActive: {
    transform: 'scale(1)',
  },

  cardInactive: {
    transform: 'scale(0.9)',
  },

  '::-webkit-scrollbar': {
    display: 'none',
  },
};

export default styles;
